import { Link } from 'react-router-dom';

const footerLinks = [
  { to: '/search', label: 'Search' },
  { to: '/category/clothing-apparel', label: 'Categories' },
  { to: '/contact', label: 'Contact' },
];

export function SiteFooter() {
  return (
    <footer className="mt-auto border-t border-slate-200 bg-white">
      <div className="container-page py-12">
        <div className="grid gap-8 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2 font-heading text-lg font-bold">
              <span className="flex h-8 w-8 items-center justify-center rounded-brand bg-brand-primary text-xs font-bold text-white">
                QR
              </span>
              QRBusiness India
            </div>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">
              Discover local businesses across India through smart QR codes. Scan, explore, and connect with shops and services near you.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500">Explore</h3>
            <ul className="mt-3 space-y-2">
              {footerLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-slate-600 transition hover:text-brand-primary">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wide text-slate-500">For businesses</h3>
            <p className="mt-3 text-sm text-slate-600">
              Get your free digital storefront and QR code. Reach customers who scan your shop QR.
            </p>
            <Link
              to="/contact"
              className="mt-3 inline-block text-sm font-medium text-brand-primary hover:underline"
            >
              List your business →
            </Link>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-2 border-t border-slate-200 pt-6 text-xs text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} QRBusiness India. All rights reserved.</p>
          <p>Made for local businesses across India</p>
        </div>
      </div>
    </footer>
  );
}
